import React, { Component } from 'react'
import { Row, Col, Icon } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { pathOr } from 'ramda';

class Usps extends Component {
    render() {
      const { training_center } = this.props;
      let count = 0;

        return (
          <Row>
            <Col lg={{ span: 24, offset: 0 }}>
              <div className="main-usp">
                {training_center.map(item => {
                  count++;
                  return (
                    <div>
                    {training_center.length === 1 &&
                      <Col span={24}>
                        <Link to={item.url ? item.url : `/post/${item.id}`}>
                          <div className="usp-full">
                            <div style={{background: `url(${item.image}) no-repeat center center`}} className="usp-image" />
                            <div className="usp-article-title-bottom">
                            <div className="usp-article-title">{item.title}</div>
                            </div>
                          </div>
                        </Link>
                      </Col>
                    }
                    {training_center.length === 2 && count === 1 &&
                      <Col span={24}>
                        <Row gutter={16}>
                          <Col xs={{ span: 24, offset: 0 }} lg={{ span: 15, offset: 0 }}>
                            <Link to={item.url ? item.url : `/post/${item.id}`}>
                              <div className="usp-full">
                                <div style={{background: `url(${item.image}) no-repeat center center`}} className="usp-image" />
                                <div className="usp-article-title-bottom">
                                  <div className="usp-article-title">{item.title}</div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                          <Col xs={{ span: 24, offset: 0 }} lg={{ span: 9, offset: 0 }}>
                            <Link to={training_center[training_center.length-1].url ? training_center[training_center.length-1].url : `/post/${training_center[training_center.length-1].id}`}>
                              <div className="usp-full">
                                <div style={{background: `url(${training_center[training_center.length-1].image}) no-repeat center center`}} className="usp-image" />
                                  <div className="usp-article-title-bottom">
                                    <div className="usp-article-title">{training_center[training_center.length-1].title}</div>
                                  </div>
                              </div>

                            </Link>
                          </Col>

                        </Row>
                      </Col>
                    }
                    {(training_center.length < 7 || training_center.length === 10) && training_center.length !== 1 && training_center.length !==2 && ((training_center.length % 2 === 1 && ![2, 5].includes(count)) || (training_center.length % 2 === 0 && ![3, 6, 9].includes(count))) ?
                      <div>
                        {((training_center.length % 2 === 1 && [1, 4].includes(count)) || (training_center.length % 2 === 0 && [2, 5, 8].includes(count))) &&
                          <Col span={24}>
                            <Row gutter={16}>
                              <Col xs={{ span: 24, offset: 0 }} lg={{ span: 15, offset: 0 }}>
                                <Link to={item.url ? item.url : `/post/${item.id}`}>
                                  <div className="usp-full">
                                    <div style={{background: `url(${item.image}) no-repeat center center`}} className="usp-image" />
                                    <div className="usp-article-title-bottom">
                                      <div className="usp-article-title">{item.title}</div>
                                    </div>
                                  </div>
                                </Link>
                              </Col>
                              <Col xs={{ span: 24, offset: 0 }} lg={{ span: 9, offset: 0 }}>
                                <Link to={training_center[count].url ? training_center[count].url : `/post/${training_center[training_center.length-1].id}`}>
                                  <div className="usp-full">
                                    <div style={{background: `url(${training_center[count].image}) no-repeat center center`}} className="usp-image" />
                                      <div className="usp-article-title-bottom">
                                        <div className="usp-article-title">{training_center[count].title}</div>
                                      </div>
                                  </div>

                                </Link>
                              </Col>

                            </Row>
                          </Col>
                        }
                        {((training_center.length % 2 === 1 && [3].includes(count)) || (training_center.length % 2 === 0 && [1, 4, 7, 10].includes(count))) &&
                          <Col span={24}>
                            <Link to={item.url ? item.url : `/post/${item.id}`}>
                              <div className="usp-full">
                                <div style={{background: `url(${item.image}) no-repeat center center`}} className="usp-image" />
                                <div className="usp-article-title-bottom">
                                <div className="usp-article-title">{item.title}</div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                        }
                      </div>
                      :
                      <div></div>
                    }
                    {(training_center.length >= 7 && training_center.length !== 10) && training_center.length !== 1 && training_center.length !==2 && ((training_center.length % 2 === 1 && ![3, 6, 9].includes(count)) || (training_center.length % 2 === 0 && ![2, 5, 8].includes(count))) ?
                      <div>
                        {((training_center.length % 2 === 1 && [2, 5, 8].includes(count)) || (training_center.length % 2 === 0 && [1, 4, 7].includes(count))) &&
                          <Col span={24}>
                            <Row gutter={16}>
                              <Col xs={{ span: 24, offset: 0 }} lg={{ span: 15, offset: 0 }}>
                                <Link to={item.url ? item.url : `/post/${item.id}`}>
                                  <div className="usp-full">
                                    <div style={{background: `url(${item.image}) no-repeat center center`}} className="usp-image" />
                                    <div className="usp-article-title-bottom">
                                      <div className="usp-article-title">{item.title}</div>
                                    </div>
                                  </div>
                                </Link>
                              </Col>
                              <Col xs={{ span: 24, offset: 0 }} lg={{ span: 9, offset: 0 }}>
                                <Link to={training_center[count].url ? training_center[count].url : `/post/${training_center[training_center.length-1].id}`}>
                                  <div className="usp-full">
                                    <div style={{background: `url(${training_center[count].image}) no-repeat center center`}} className="usp-image" />
                                      <div className="usp-article-title-bottom">
                                        <div className="usp-article-title">{training_center[count].title}</div>
                                      </div>
                                  </div>

                                </Link>
                              </Col>

                            </Row>
                          </Col>
                        }
                        {((training_center.length % 2 === 1 && [1, 4, 7].includes(count)) || (training_center.length % 2 === 0 && [3, 6].includes(count))) &&
                          <Col span={24}>
                            <Link to={item.url ? item.url : `/post/${item.id}`}>
                              <div className="usp-full">
                                <div style={{background: `url(${item.image}) no-repeat center center`}} className="usp-image" />
                                <div className="usp-article-title-bottom">
                                <div className="usp-article-title">{item.title}</div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                        }
                      </div>
                    : <div></div>
                    }
                  </div>
                  )
                })}

                {/* <Col style={{zIndex: '9'}} span={24}>
                  <Link to="/door-objectieve-matching-meer-toewijding-en-werkplezier">
                    <div className="usp-full">
                      <div className="usp-image usp-full-1" />
                      <div className="usp-article-title-bottom">
                        <div className="usp-article-title">Met unlocQed meer toewijding en werkplezier</div>
                      </div>
                    </div>
                  </Link>
                </Col>

                 <Col span={24}>
                  <Row gutter={16}>
                    <Col xs={{ span: 24, offset: 0 }} lg={{ span: 15, offset: 0 }}>
                      <Link to="/ben-jij-óók-op-zoek-naar-die-leukere-baan">
                        <div className="usp-full">
                          <div style={{background: `url(${item.image}) no-repeat center center`}} className="usp-image" /><div className="usp-image usp-full-2" />
                          <div className="usp-article-title-bottom">
                            <div className="usp-article-title">Ben jij ook op zoek naar die leukere baan</div>
                          </div>
                        </div>
                      </Link>
                    </Col>
                    <Col xs={{ span: 24, offset: 0 }} lg={{ span: 9, offset: 0 }}>
                      <Link to="/team-members">
                        <div className="usp-full">
                          <div className="usp-image usp-full-blue" />
                            <div className="usp-article-title-bottom">
                              <div className="usp-article-title">Ons team</div>
                            </div>
                        </div>

                      </Link>
                    </Col>

                  </Row>
                </Col>

                <Col span={24}>
                  <Link to="/persbericht">
                    <div className="usp-full">
                      <div className="usp-image usp-full-3" />
                        <div className="usp-article-title-bottom">
                          <div className="usp-article-title">Zes miljoen werknemers staan open voor een betere baan</div>
                        </div>
                    </div>
                  </Link>
                </Col>

                <Col span={24}>
                  <Row gutter={16}>
                  <Col xs={{ span: 24, offset: 0 }} lg={{ span: 9, offset: 0 }}>
                      <Link to="/privacy-by-design">
                        <div className="usp-full">
                        <div className="usp-image usp-full-4" />
                          <div className="usp-article-title-bottom">
                            <div className="usp-article-title">Privacy by design</div>
                          </div>
                        </div>

                      </Link>
                    </Col>
                    <Col xs={{ span: 24, offset: 0 }} lg={{ span: 15, offset: 0 }}>
                      <Link to="/jij-vind-dè-baan-en-de-wereld-krijgt-meer-zuurstof">
                        <div className="usp-full">
                          <div className="usp-image usp-full-6"></div>
                          <div className="usp-article-title-bottom">

                            <div className="usp-article-video">
                              <Icon type="caret-right" theme="filled" style={{fontSize: 22, color: 'white', marginRight: 5}} />
                              WATCH VIDEO
                            </div>
                            <div className="usp-article-title">Jij vindt dè baan en de wereld krijgt meer zuurstof</div>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  </Row>
                </Col> */}

              </div>
            </Col>
          </Row>
        )
    }
}

// export default Usps
export default compose(
	firestoreConnect((props) => {

    return [
      {
        collection: 'training_center',
        where: [
          ['isPublished', '==', true],
          ['isHomePage', '==', true]
        ]
      }
    ]
	}),
	connect((state, props) => {
    const { ordered } =  pathOr('', ['firestore'], state);
    const sorted_training_center = pathOr([], ['training_center'], ordered)
    .sort((x, y) => {
      return y.createdAt.seconds - x.createdAt.seconds;
    })
		return {
      training_center: sorted_training_center,
    };
  })
)(Usps);

